import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import { useLocation } from "react-router";
import eventTracker from "../../../utils/eventTracker";
import { TOKEN_KEY } from '../../../config/constants'
import VeloraRedirectStyled from './styled'
import i18n from '../../../assets/i18n'

const VelorahrRedirectLanding = () => {

  const location = useLocation();
  useEffect(() => {
    let pathname = location.pathname;
    eventTracker.track('VeloraRedirectLanding', {
      id: pathname
    });
  }, []);

  const accessToken = localStorage.getItem(TOKEN_KEY);

  return <VeloraRedirectStyled>
    <div className="containerHeader">
    <Grid container spacing={4}>
      <Grid item className="sectionSecond" xs={12} sm={12}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start", gridGap: '15px', maxWidth: "800px", }}>
          <h2>{i18n.veloraRedirect?.title}</h2>
          <h5>{i18n.veloraRedirect?.description}</h5>
          <Button variant="contained" color="primary" href={`https://ats.velorahr.com?access_token=${accessToken}`} target="_blank" rel="noopener noreferrer">
            {i18n.veloraRedirect?.button}
          </Button>
        </Box>
      </Grid>
    </Grid>
    </div>
  </VeloraRedirectStyled>
}

VelorahrRedirectLanding.propTypes = {
  i18n: PropTypes.object.isRequired,
}

export default VelorahrRedirectLanding
